import Icon from '@/components/ui/AppIcon';

interface ProcessStep {
  id: string
  number: string
  title: string
  description: string
  icon: string
}

export default function ProcessFlow() {
  const steps: ProcessStep[] = [
    {
      id: 'step_1',
      number: '01',
      title: 'Discovery & Strategy',
      description:
        'We start by understanding your business goals, target audience, and unique challenges to create a tailored strategy.',
      icon: 'LightBulbIcon',
    },
    {
      id: 'step_2',
      number: '02',
      title: 'Design & Development',
      description:
        'Our expert team brings your vision to life with stunning designs and robust development practices.',
      icon: 'PaintBrushIcon',
    },
    {
      id: 'step_3',
      number: '03',
      title: 'Testing & Refinement',
      description:
        'Rigorous testing ensures everything works flawlessly before launch. We refine until perfect.',
      icon: 'BeakerIcon',
    },
    {
      id: 'step_4',
      number: '04',
      title: 'Launch & Support',
      description:
        'We launch your project with confidence and provide ongoing support to ensure continued success.',
      icon: 'RocketLaunchIcon',
    },
  ]

  return (
    <section className="py-20 md:py-32 bg-zinc-950 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 reveal">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-[2px] h-4 bg-amber-500" />
            <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
              Our Process
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-white">
            How We Work
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            A proven 4-step process that delivers exceptional results every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, idx) => (
            <div
              key={step.id}
              className="relative reveal"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              {/* Connector Line - hidden on mobile, shown on lg+ */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-24 left-full w-full h-[2px] bg-zinc-800 -z-10" />
              )}

              <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 hover:border-amber-500/30 transition-all glow-hover h-full">
                <div className="text-6xl font-bold text-zinc-800 mb-4">
                  {step.number}
                </div>
                <div className="w-12 h-12 mb-4 flex items-center justify-center text-amber-500 bg-amber-500/10 rounded-xl">
                  <Icon name={step.icon as any} size={24} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">{step.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}